<template>
    <card>
        <span slot="header">
            {{ initialIVR.name }}
            <span class="right text-success" v-if="!dirty">Synced</span>
            <span class="right text-warning" v-if="dirty">Not Saved</span>
        </span>
        <div v-if="loading" class="loading">
            <div class="text-center" style="font-size: 5rem;">
                <font-awesome-icon :icon="['fal','spinner-third']"
                                   spin></font-awesome-icon>
            </div>
        </div>
        <el-tabs v-model="activeTab">
            <el-tab-pane :lazy="true" label="Keys" name="keys">
                <IVRKeys :initial-i-v-r="initialIVR" v-on:button-add="reload" v-on:button-remove="reload"></IVRKeys>
            </el-tab-pane>
            <el-tab-pane :lazy="true" label="Settings" name="settings">

                <base-input
                    :error="getError('name')"
                    :name="name"
                    :ref="name"
                    :value="name"
                    @input="handleNameInputChange(initialIVR.id,$event)"
                    label="Name"
                    required
                    v-validate="'required|min:3|max:50'"
                ></base-input>
                <system-recording-selector @change="dirty = true"
                                           v-model="recording"></system-recording-selector>
                <label>Default action</label>
                <select @change="dirty = true" class="form-control" id="ivr-default-action"
                        v-model="default_action">
                    <option value="hangup">Hangup</option>
                    <option value="repeat">Repeat Message</option>
                    <option value="other">Other</option>
                </select>

                <span class="info"
                      v-if="this.default_action !== initialIVR.default_action && initialIVR.default_action !== 'other'">This will remove the current default action and overwrite it! </span>


            </el-tab-pane>
        </el-tabs>
        <div slot="footer">
            <div class="row">
                <div class="col">
                    <base-button class="left" :loading="saving"
                                 @click="save" type="primary">
                        Save
                    </base-button>
                    <el-tooltip content="Delete this IVR, its buttons all the linked callflows!"
                                effect="dark"
                                :open-delay="300"
                                placement="top">
                        <base-button icon @click="remove()" type="danger"
                                     :loading="removing[initialIVR.id]" class="right">
                            <font-awesome-icon v-show="!removing[initialIVR.id]"
                                               :icon="['fal','trash']"></font-awesome-icon>
                        </base-button>
                    </el-tooltip>
                </div>
            </div>
        </div>
    </card>
</template>

<script>
import AddButtonModal from "./AddButtonModal";
import swal from 'sweetalert2';
import IVRKeys from "./IVRKeys";
import SystemRecordingSelector from "../../components/SystemRecording/SystemRecordingSelector";

export default {
    name: "IVRCard",
    components: {
        SystemRecordingSelector,
        IVRKeys,
        AddButtonModal,
        swal,
    },
    props: {
        initialIVR: Object,
    },
    data() {
        return {
            name: this.initialIVR.name,
            recording: this.initialIVR.recording,
            default_action: this.initialIVR.default_action,
            dirty: false,
            saving: false,
            removing: [],
            loading: false,
            activeTab: 'keys'
        }
    },
    methods: {
        getError(fieldName) {
            return this.errors.first(fieldName)
        },
        handleNameInputChange(id, value) {
            this.name = value.replace(/[#,."'/\\`~:;}{|$&%^?+*]/g, '');
            this.dirty = true;
        },

        remove() {
            let ivr = this.initialIVR.id;
            swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to restore this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) {
                    this.$set(this.removing, ivr, true);
                    this.$store.dispatch('ivr/remove', {ivr}).then(() => {
                        this.$notify({
                            verticalAlign: 'bottom',
                            horizontalAlign: 'right',
                            message: 'Your IVR was removed!',
                            type: "success",
                            icon: "fal fa-trash",
                            title: "Removed!"
                        });

                    }).catch(() => {
                        this.$notify({
                            position: "bottom-right",
                            message: 'Your IVR failed to remove!',
                            type: "error",
                            icon: "fal fa-times",
                            title: "Error!"
                        });
                    }).finally(() => {
                        this.$set(this.removing, ivr, false);
                    });
                }
            });
        },
        save() {
            let ivr = this.initialIVR.id;
            let name = this.name;
            let default_action = this.default_action;
            let recording = this.recording;
            this.saving = true;

            this.$store.dispatch('ivr/saveSettings', {ivr, name, default_action, recording}).then(() => {
                this.$notify({
                    verticalAlign: 'bottom',
                    horizontalAlign: 'right',
                    message: 'Your IVR was saved!',
                    type: "success",
                    icon: "fal fa-save",
                    title: "Saved!"
                });
                this.reload();
                this.$emit('save');
            }).catch(() => {
                this.$notify({
                    position: "bottom-right",
                    message: 'Your IVR failed to save!',
                    type: "error",
                    icon: "fal fa-times",
                    title: "Error!"
                });
            }).finally(() => {
                this.saving = false;
            });
        },
        reload() {
            this.loading = true;
            let ivr = this.initialIVR.id;
            this.$store.dispatch('ivr/reload', {ivr}).then(() => {
                this.dirty = false;
            }).finally(() => {
                this.loading = false;
            });
        },
    },
}
</script>

<style scoped>
.loading {
    position: absolute;
    z-index: 2;
    margin: -15px;
    margin-top: -48px;
    height: 100%;
    width: 100%;
    background: rgba(240, 240, 240, 0.6);
}

.loading:before {
    content: '';
    height: 100%;
    display: inline-block;
    vertical-align: middle;
}

.loading > div {
    display: inline-block;
    vertical-align: middle;
    width: 100%;
}
</style>
